import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApplicationsRoutingModule } from './applications-routing.module';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { AppsRestClient } from './services/apps-rest-client.service';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { ApplicationListItemComponent } from './components/application-list-item/application-list-item.component';
import { EnabledApplicationListComponent } from './components/enabled-application-list/enabled-application-list.component';
import { EffectsModule } from '@ngrx/effects';
import { MetaReducer, StoreModule } from '@ngrx/store';
import { applications } from './applications.store';
import { FormsModule } from '@angular/forms';
import { ManageApplicationsComponent } from './components/manage-applications/manage-applications.component';
import { ConfigModule } from '../config/config.module';
import { AppBrandIdentifierComponent } from './components/app-brand-identifier/app-brand-identifier.component';
import { ApplicationDeleteEffects } from './effects/application-delete.effects';
import { ApplicationListEffects } from './effects/application-list.effects';
import { ApplicationDetailEffects } from './effects/application-detail.effects';
import { UrlParamsModule } from '../url-params/url-params.module';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { CoreModule, createTranslateLoader } from '../../core/core.module';
import { UpdatePermissionsDialogComponent } from './components/update-permissions-dialog/update-permissions-dialog.component';
import { ConsentModule } from '../consent/consent.module';
import { ApplicationUpdatePermissionsEffects } from './effects/application-update-permissions.effects';
import { ApplicationEffects } from './effects/application.effects';
import { ApplicationsState } from './applications.state';
import { createClearReducer } from '../../core/reducers/meta/clear.reducer';
import * as applicationActions from './actions/application.actions';


export const metaReducers: MetaReducer<ApplicationsState>[] = [createClearReducer(applicationActions.CLEAR_STORE)];

/**
 * Module wraps application management and company applications components and functionality.
 * It has its own:
 * - local routing
 * - application state
 * - ngrx side effects
 * - components
 */
@NgModule({
    imports: [
        ConfigModule,
        UrlParamsModule,
        CoreModule,
        ConsentModule,
        TranslateModule.forChild({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            }
        }),
        CommonModule,
        FormsModule,
        HttpClientModule,
        SharedModule,
        RouterModule,
        ApplicationsRoutingModule,
        StoreModule.forFeature('applications', applications, { metaReducers }),
        EffectsModule.forFeature([
            ApplicationEffects,
            ApplicationListEffects,
            ApplicationDetailEffects,
            ApplicationDeleteEffects,
            ApplicationUpdatePermissionsEffects
        ]),
    ],
    declarations: [
        UpdatePermissionsDialogComponent,
        AppBrandIdentifierComponent,
        ManageApplicationsComponent,
        ApplicationListItemComponent,
        EnabledApplicationListComponent
    ],
    exports: [
        CommonModule,
        FormsModule,
        HttpClientModule,
        RouterModule,
        ConfigModule,
        SharedModule,
        AppBrandIdentifierComponent
    ],
    entryComponents: [
        UpdatePermissionsDialogComponent,
        ApplicationListItemComponent
    ],
    providers: [  AppsRestClient ]
})
export class ApplicationsModule {}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/applications/applications.module.ts